<template>
  <div class="col-table" @touchstart="touchstart" @touchend="touchend">
    <div style="display: none">
      <slot></slot>
    </div>
    <col-table-body :data="data" :rows="rows" :columnWidth="columnWidth"></col-table-body>
  </div>
</template>

<script>
import ColTableBody from './body.vue'
export default {
  name: 'ColTable',
  components: { ColTableBody },
  props: {
    data: {
      type: Array,
      required: true
    },
    pageSize: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      rows: [],
      tableWidth: 0,
      headerWidth: 0,
      columnWidth: 0,
      pageNum: 1
    }
  },
  computed: {
    total() {
      return this.data.length - this.pageSize + 1
    }
  },
  watch: {
    pageSize() {
      this.pageNum = 1
      this.columnWidth = this.getColumnWidth()
    },
    pageNum() {
      this.scrollTo(this.getScrollLeft())
    }
  },
  activated() {
    this.$el.scrollLeft = this.getScrollLeft()
  },
  mounted() {
    this.getRows()
    this.$nextTick(() => {
      const domRow = this.$el.querySelector('.col-table__row')
      const domHeader = domRow.querySelector('.col-table__td--header')
      this.headerWidth = domHeader.offsetWidth
      this.tableWidth = this.$el.offsetWidth
      this.columnWidth = this.getColumnWidth()
    })
  },
  methods: {
    getScrollLeft() {
      return (this.pageNum - 1) * this.columnWidth
    },
    getColumnWidth() {
      return (this.tableWidth - this.headerWidth) / this.pageSize
    },

    scrollTo(left) {
      this.$el.scrollTo({ left, behavior: 'smooth' })
    },

    touchstart(e) {
      this.startX = e.changedTouches[0].clientX
      this.startY = e.changedTouches[0].clientY
    },

    touchend(e) {
      const endX = e.changedTouches[0].clientX
      const endY = e.changedTouches[0].clientY
      const directionX = endX - this.startX
      const directionY = endY - this.startY
      if (Math.abs(directionX) > Math.abs(directionY)) {
        if (Math.abs(directionX) < 50) return
        if (directionX < 0) {
          if (this.pageNum < this.total) {
            this.pageNum = this.pageNum + 1
          }
        } else {
          if (this.pageNum > 1) {
            this.pageNum = this.pageNum - 1
          }
        }
      }
    },

    getRows() {
      const childrens = this.$slots.default
      const rowConponents =
        childrens?.filter((item) => {
          return item.tag && item.componentOptions && item.componentOptions.Ctor.options.name === 'ColTableColumn'
        }) ?? []
      this.rows = rowConponents.map((item) => {
        const { label, prop, css, rowStyle, rowClass, $scopedSlots } = item.componentInstance
        const row = {
          label,
          prop,
          css,
          rowStyle,
          rowClass,
          headerCellSlot: null,
          bodyCellSlot: null
        }
        let bodyCellSlot = row.bodyCellSlot
        row.bodyCellSlot = (createElement, data) => {
          if ($scopedSlots.default) {
            bodyCellSlot = () => $scopedSlots.default(data)
          } else {
            bodyCellSlot = () => {
              const { row } = data
              return row[prop]
            }
          }
          return bodyCellSlot()
        }
        let headerCellSlot = row.headerCellSlot
        row.headerCellSlot = (createElement, data) => {
          if ($scopedSlots.header) {
            headerCellSlot = () => $scopedSlots.header(data)
          } else {
            headerCellSlot = () => this.$t(label)
          }
          return headerCellSlot()
        }
        return row
      })
    }
  }
}
</script>

<style lang="scss">
.col-table {
  // 背景色
  --col-table-bg-color: var(--bg-color-2);
  // 字体色
  --col-table-header-font-color: var(--font-color-3);
  --col-table-body-font-color: var(--font-color-1);
  // 字体大小
  --col-table-header-font-size: 13px;
  --col-table-body-font-size: 13px;
  // 行边距
  --col-table-row-padding: 5px 0;
  // 宽度
  --col-table-title-width: 150px;

  background: var(--col-table-bg-color);
  overflow: hidden;

  .col-table__content {
    display: inline-block;
    background: var(--col-table-bg-color);
  }

  .col-table__row {
    display: flex;
    padding: var(--col-table-row-padding);
  }

  .col-table__td {
    background: var(--col-table-bg-color);
  }

  .col-table__td--header {
    position: sticky;
    left: 0;
    z-index: 1;
    flex-shrink: 0;
    width: var(--col-table-title-width);
    color: var(--col-table-header-font-color);
    font-size: var(--col-table-header-font-size);
  }

  .col-table__td--body {
    color: var(--col-table-body-font-color);
    font-size: var(--col-table-body-font-size);
    text-align: right;
  }
}
</style>
